import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor() { }

  min_length_name = 2;
  max_length_name = 150;
  min_length_code = 2;
  max_length_code = 10;
  min_length_address = 10;
  max_length_address = 250;
  // min_length_email = 5; // minimum length are not required for email pattern
  max_length_email = 120;
  min_length_contact = 10;
  max_length_contact = 12;
  min_length_description = 10;
  max_length_description = 150;
  max_length_credits = 20;


  // Character validation on name fields is intentionally removed — every special character is
  // allowed (product decision). The patterns are kept (instead of stripping Validators.pattern
  // from every form) so the shared bulk-upload column config keeps working; they now accept
  // anything and only required / min / max length still apply.
  // < and > are allowed too, so anything that renders a name into HTML must escape it — the BE
  // email templates do that via escape_html (src/utils/escape-html.ts in novamark-be).
  location_name_pattern = /^[\s\S]*$/;
  name_pattern = /^[\s\S]*$/;
  code_pattern = /^[a-zA-Z0-9&-]+$/;
  address_pattern = /^[a-zA-Z0-9 !@#$%&*()-_+={},|:;"'<>,.?/]+$/;
  email_pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  year_range_pattern = /^\d{4}-\d{4}$/;
  contact_pattern = /^[0-9]+$/;
  aadhar_pattern = /^\d{12}$/;
  pan_pattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  gst_pattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  pincode_pattern = /^[0-9]{6}$/;
  new_name_pattern = /^[\s\S]*$/;
  roll_number_pattern = /^[A-Za-z0-9][A-Za-z0-9/-]*$/;
  // validation.service.ts
  password_complex_pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;

}
